<template>
    <ac-modal :title="'Price Tiers'" ref="modalRef">
        <template v-if="widgetReady">
            <price-tiers :read-only="true" :plan-id="planId"></price-tiers>
        </template>
    </ac-modal>
</template>

<script>
    import PriceTiers from "./PriceTiers.vue";

    export default {
        name: "PriceTierModal",
        props: {
            planId: {type: [Number], required: false, default: 0},
            readOnly: {type: [Boolean], required: false, default: false},
        },
        components: {PriceTiers},
        data() {
            return {
                widgetReady: false
            }
        },
        methods: {
            async showModal(planId) {
                this.planId = planId;
                this.$refs.modalRef.open();
            },
            cancel() {
                this.$refs.modalRef.close();
            },
        },
        async mounted() {
            this.widgetReady = true;
        },
    }
</script>

<style scoped>
</style>